import { render, staticRenderFns } from "./DashboardInfo.vue?vue&type=template&id=04c087d2"
import script from "./DashboardInfo.vue?vue&type=script&lang=ts"
export * from "./DashboardInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports